import { Infer, t } from 'typegate';
import { participantMedicalInterviewStatusSchema } from '../participantMedicalInterview';
import { Language } from '../localization';

export enum MedicalInterviewProvider {
  AuraNext = 'AuraNext',
}

export const MedicalInterviewRequestDataConfigsSchema = t.object(
  t.property('interviewId', t.string),
  t.property('projectId', t.string),
  t.property('carrierCode', t.string),
);
export type MedicalInterviewRequestDataConfigs = Infer<typeof MedicalInterviewRequestDataConfigsSchema>;

export const buildAuraNextInputXmlSchema = t.object(
  t.property('applicationId', t.string),
  t.property('participantId', t.string),
);
export type BuildAuraNextInputXml = Infer<typeof buildAuraNextInputXmlSchema>;

export const buildAuraNextInputXmlResponseSchema = t.object(
  t.property('status', t.string),
  t.property('correspondenceLanguage', t.enum(Language)),
  t.property('inputXml', t.string),
);
export type BuildAuraNextInputXmlResponse = Infer<typeof buildAuraNextInputXmlResponseSchema>;

export const updateMedicalInterviewSchema = t.object(
  t.property('participantId', t.string),
  t.property('status', participantMedicalInterviewStatusSchema),
);
export type UpdateMedicalInterview = Infer<typeof updateMedicalInterviewSchema>;

export const MedicalInterviewConfigsSchema = t.object(
  t.property('enabled', t.boolean),
  t.property('provider', t.enum(MedicalInterviewProvider)),
  t.property(
    'auraNext',
    t.object(
      t.property('accessTokenUrl', t.string),
      t.property('auraEnvAndDeployment', t.string),
      t.property('carrierCode', t.string),
      t.property('interviewId', t.string),
      t.property('projectId', t.string),
    ),
  ),
);
export type MedicalInterviewConfigs = Infer<typeof MedicalInterviewConfigsSchema>;
